import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { returnState, useAppLocation } from '#hooks/useAppLocation.ts';

type Props = {
  /** Fallback location in case there is no `from` in state */
  fallbackTo: NonNullable<React.ComponentProps<typeof LinkButton>['to']>;
} & Omit<React.ComponentProps<typeof LinkButton>, 'to' | 'variant' | 'href'>;

/**
 * A cancel button for forms that attempts to return to `location.state.from`, and if
 * that's not there, then to a fallback location. Restores the return chain so the origin
 * page's own back-navigation keeps working (see returnState).
 */
export function CancelLinkButton({ fallbackTo, ...props }: Props) {
  const from = useAppLocation().state?.from;

  return (
    <LinkButton variant="link" to={from ?? fallbackTo} state={returnState(from)} {...props}>
      Cancel
    </LinkButton>
  );
}
